import * as React from "react";
const SvgFiRrGuitarElectric = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-guitar-electric_svg__a)">
      <path
        fill="#062147"
        d="M23.707.293a1 1 0 0 0-1.096-.214C22.151.148 18 .801 18 1.844c0 .212.169 1.411.853 1.889L13.486 9.1a4.504 4.504 0 0 1 .712-5.432.997.997 0 0 0 0-1.414 1 1 0 0 0-1.414 0c-.64.64-1.051 1.02-1.351 1.298-.71.657-.908.859-1.713 2.075C8.645 7.252 7.626 7.91 5.359 8.446q-.418.098-.804.181c-1.22.267-2.273.498-2.953 1.177-3.51 3.51-.566 6.538 2.031 9.209l1.213 1.261c1.887 1.985 3.517 3.699 5.548 3.724h.046c1.133 0 2.215-.531 3.306-1.622.707-.707 1.082-1.948 1.498-3.499.573-2.132 1.158-2.902 3.13-4.12 1.498-.925 2.843-2.557 2.899-2.626a1 1 0 0 0-1.372-1.434c-1.488 1.11-3.476 1.034-5.064-.123l8.87-8.867a1 1 0 0 0 0-1.414M13.313 18.361c-.237.883-.596 2.219-.98 2.603-.705.705-1.364 1.037-1.912 1.036-1.188-.015-2.549-1.446-4.124-3.103l-1.229-1.278c-3.086-3.174-3.994-4.458-2.051-6.401.265-.265 1.13-.455 1.967-.638q.4-.087.836-.188c2.169-.513 3.683-1.172 5.088-2.989.112 1.312.481 2.707 1.731 3.957s2.714 1.906 4.08 2.086c-1.958 1.317-2.762 2.519-3.406 4.915m-.737-4.437a.999.999 0 1 1-1.414 1.414l-2.5-2.5a.999.999 0 1 1 1.414-1.414zm-2.763 2.763a.999.999 0 1 1-1.414 1.414l-2.5-2.5a.999.999 0 1 1 1.414-1.414z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-guitar-electric_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGuitarElectric;
